import HelpInteractions from './helping';

export default {
    __init__ : [ 'helpInteractions' ],
    helpInteractions: [ 'type', HelpInteractions ]
};